import React, { useContext, useState } from 'react'
import {
    Grid,
  
    makeStyles, 
  
    Card, 
    CardContent, 
  
   } from '@material-ui/core';

import TblDetalleConsultasRut from './TblDetalleConsultasRut'
import TblDOcumentoPortalchq from './TblDOcumentoPortalchq'
import { TblOrdenesnoPago } from './TblOrdenesnoPago'
import TblDocumentoProtestado from './TblDocumentoProtestado';
import TblEstructuraFinanciera from './TblEstructuraFinanciera';
import UserContext from '../../context/Globales/UserContext';
import { Button } from '@material-ui/core';
//import FondoImagenes from '/static/imagen/fondo.jpg';
const useStyles = makeStyles((theme) => ({ 
    tituloTable: {
    
        backgroundColor: '#e6e6e6', 
        minWidth: 200,
        color: 'black',
        textAlign: 'center',
        padding: '16px',
        fontWeight: '250',
        fontSize : '16px'
     },  
    TituloIdentificacion: {

        backgroundColor: theme.palette.primary.main, 
        backgroundImage : `url(${process.env.PUBLIC_URL+'/static/imagen/fondo.jpg'})`,
        minWidth: 200,
        color: 'black',
        textAlign: 'left',
        padding: '15px',
        fontWeight: '450',
        fontSize : '18px',
        height: 'auto',
        alignContent: 'center',               
     },
    fondoTituloIndicadores: {

        backgroundColor: theme.palette.fondotitulos.main,
        minWidth: 200,
        color: '#171717',
        textAlign: 'center',
        padding: '15px',
        fontWeight: '250',
        fontSize : '18px',
        height: 'auto',
        alignContent: 'center',               
     },

    FondoTable :{
       
        backgroundColor: theme.palette.greyFondo.main
    }

}))

const AsignacionTable = () => {
    const classes = useStyles();
   
  
    

    return (
        <div>
            
            <Grid component="main">
            <div className={classes.TituloIdentificacion}>COMPORTAMIENTO</div>
          
       
            <Grid  container direction="row" spacing={2}>  
           {/* <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                
             
                <div className={classes.fondoTituloIndicadores}>El Rut Registra <b></b>({datoIC && datoIC.DetallesConsultasRut?.NumeroConsultas}) en los Ultimos 6 meses  &nbsp;
                <Button variant="outlined" color="primary" onClick={VerDatelleConsultaRut}>{stateTable ? 'Ocultar Detalle' : 'Ver Información' }</Button> </div>
                    {stateTable ? 
                   <TblDetalleConsultasRut /> 
                    : '' }
            </Grid>  */}            

            <Grid item xs={12} sm={12} xl={12} md={12} lg={12} >
               
              
                <div className={classes.fondoTituloIndicadores}>Documentos portal cheque </div>
                       
                    < TblDOcumentoPortalchq />
                
            </Grid>
         
      
          
            
            </Grid> 

          
        
         
            </Grid>
        </div>
    )
}

export default AsignacionTable
